export const PARTNER_PANEL_URL = "https://partners.shoppub.com.br/admin/login";

export const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=5516982630012&text=Ol%C3%A1%2C+estou+interessado+em+saber+mais+sobre+a+Shoppub&type=phone_number&app_absent=0";

export const NAV_LINKS = [
  { label: "A plataforma", href: "/plataforma" },
  { label: "Funcionalidades", href: "/funcionalidades" },
  { label: "Vendas ao vivo", href: "/mapa" },
  { label: "Conhecimento", href: "https://conhecimento.shoppub.io/", external: true },
] as { label: string; href: string; external?: boolean }[];

export const HERO_ROTATIONS = [
  {
    highlight: "que entende de moda",
    sub: "Grade aberta e fechada, atacado e varejo, com as melhores práticas do segmento de moda.",
  },
  {
    highlight: "especializada em marca própria",
    sub: "Design, variações, sugestão de produtos e grade de cores e numeração para marcas únicas.",
  },
  {
    highlight: "que mais converte no Brasil",
    sub: "O fluxo de compra mais rápido do mercado, com recursos avançados de UX e checkout sem senha.",
  },
  {
    highlight: "radicalmente humana",
    sub: "Do onboarding ao crescimento, estamos ao seu lado com suporte, consultores e agências especializadas.",
  },
];

export const HERO_PILLS = [
  "Layout personalizado",
  "Especialista em grade",
  "Campanhas inteligentes",
  "Agentes de IA",
  "CS especializado",
  "Ofertas no fluxo de compra",
  "Catálogo para moda",
];
